import React from 'react';
import { RequestStateProps } from 'acscp/components/common/helpers/requestStateProps';
import { getTranslatableErrorMessage } from 'acscp/components/common/helpers/getTranslatableErrorMessage';
import { ErrorsDisplay } from 'acscp/components/common/errorsDisplay';

const RequestErrorMessage: React.SFC<{requestState: RequestStateProps, className?: string}> =
    ({requestState, className}) => {

    if (!requestState.requestError) {
        return <ErrorsDisplay className={className} errors={[]} />;
    }

    const errorMessage = getTranslatableErrorMessage(requestState.requestError.message);
    return <ErrorsDisplay className={className} errors={[errorMessage]} />;
};

export { RequestErrorMessage };
